import { EnglishArabicDTO } from "bbsf-controls"
export class SendEmailTemplateModel
{
      TemplateID:number
      LangKey :string
      ToEmails :string
      EmailProviderName:string
      ErrorMessage:string
      IsSuccess:boolean


}